import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { underwritingQueueService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseQaUnclaimMutationProps = {
	id: string;
	onSuccessHandler?: Function;
};

const useQaUnclaimMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseQaUnclaimMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return underwritingQueueService.unclaimCurrentUserOnQaUw({
				id,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess(_data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Unclaim has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useQaUnclaimMutation;
